/* Kesvara Atelier: Light Lab. Plain JS, no libraries. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';
  function readJSON(sel, root) { var el = $(sel, root); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var CFG = readJSON('[data-kx-at-cfg]');
  if (!CFG) return;
  var IDX = CFG.idx || {};

  /* ---------- colour ---------- */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function k2rgb(k) {
    var t = k / 100, r, g, b;
    r = t <= 66 ? 255 : 329.698727446 * Math.pow(t - 60, -0.1332047592);
    g = t <= 66 ? 99.4708025861 * Math.log(t) - 161.1195681661 : 288.1221695283 * Math.pow(t - 60, -0.0755148492);
    b = t >= 66 ? 255 : (t <= 19 ? 0 : 138.5177312231 * Math.log(t - 10) - 305.0447927307);
    return [clamp(Math.round(r), 0, 255), clamp(Math.round(g), 0, 255), clamp(Math.round(b), 0, 255)];
  }
  function shown(k) { return k >= 5000 ? Math.min(9500, k * 1.3) : (k >= 3800 ? k * 1.08 : k); }
  function css(c, a) { return a == null ? 'rgb(' + c.join(',') + ')' : 'rgba(' + c.join(',') + ',' + a + ')'; }
  function mix(a, b, t) { return [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * t); }); }
  function hex(h) { h = h.replace('#', ''); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }

  /* ---------- product options: read and write the buy box, with local fallback ---------- */
  var OPT = {};
  function theForm() { return $('[data-kx-pdp] form.product_form') || $('form.product_form'); }
  function radios(kind) {
    var i = IDX[kind], f = theForm();
    if (i == null || i < 0 || !f) return [];
    return $$('input[type=radio][name="option-' + i + '"]', f);
  }
  function getOpt(kind) {
    var rs = radios(kind), n;
    for (n = 0; n < rs.length; n++) if (rs[n].checked) return rs[n].value;
    return OPT[kind] || null;
  }
  function setOpt(kind, val) {
    OPT[kind] = val;
    radios(kind).forEach(function (r) {
      if (r.value === val && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  var f0 = theForm();
  if (f0) f0.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.name || t.name.indexOf('option-') !== 0) return;
    var lab = $('[data-kx-optval="' + t.name.split('-')[1] + '"]', f0); if (lab) lab.textContent = t.value;
  });
  var FINISH = { black: ['#151617', '#2a2c2e'], white: ['#e8e6e1', '#ffffff'], gold: ['#a77e3c', '#e2c27f'] };
  function finishKey(v) { v = (v || '').toLowerCase(); if (/gold|dor|oro/.test(v)) return 'gold'; if (/white|blanc|bianc/.test(v)) return 'white'; return 'black'; }
  function woodKey(v) { v = (v || '').toLowerCase(); return /walnut|noyer|noce/.test(v) ? 'walnut' : 'oak'; }
  function tones() { return CFG.tones || {}; }
  function toneName() { var t = getOpt('tone'); return (t && tones()[t]) ? t : Object.keys(tones())[0]; }
  function toneK(name, step) {
    var t = tones()[name]; if (!t) return 3000;
    return Array.isArray(t.k) ? t.k[(step || 0) % t.k.length] : t.k;
  }
  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  var uid = 0;

  $$('[data-kx-lab]').forEach(function (root) {
    var stage = $('[data-kx-stage]', root), host = $('[data-kx-scene]', root);
    if (!stage || !host) return;
    var I18N = readJSON('[data-kx-lab-i18n]', root) || {};
    var id = 'kxl' + (++uid);
    var W = 1600, H = 1000;
    var S = { amb: 0.18, beam: 0.38, rain: false, orient: 'v', step: 0, on: true, level: 1, aimX: 1050, aimY: 640, rot: 62, flick: 0 };
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, preserveAspectRatio: 'xMidYMid slice', 'aria-hidden': 'true', focusable: 'false' });
    host.appendChild(svg);
    var defs = el('defs', {}, svg);
    defs.innerHTML =
      `<filter id='${id}n' x='0' y='0' width='100%' height='100%'><feTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix type='saturate' values='0'/><feComponentTransfer><feFuncA type='table' tableValues='0 .09'/></feComponentTransfer></filter>` +
      `<filter id='${id}b1' x='-50%' y='-50%' width='200%' height='200%'><feGaussianBlur stdDeviation='10'/></filter>` +
      `<filter id='${id}b2' x='-50%' y='-50%' width='200%' height='200%'><feGaussianBlur stdDeviation='26'/></filter>` +
      `<filter id='${id}b3' x='-60%' y='-60%' width='220%' height='220%'><feGaussianBlur stdDeviation='60'/></filter>` +
      `<filter id='${id}trav' x='0' y='0' width='100%' height='100%'><feTurbulence type='fractalNoise' baseFrequency='.012 .16' numOctaves='3' seed='7'/><feColorMatrix values='0 0 0 0 .80  0 0 0 0 .73  0 0 0 0 .60  0 0 0 -1.1 1.05'/><feComposite in2='SourceGraphic' operator='in'/></filter>` +
      `<filter id='${id}grain' x='0' y='0' width='100%' height='100%'><feTurbulence type='fractalNoise' baseFrequency='.004 .09' numOctaves='2' seed='3'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -.9 .55'/><feComposite in2='SourceGraphic' operator='in'/></filter>` +
      `<linearGradient id='${id}up' x1='0' y1='1' x2='0' y2='0'><stop offset='0' style='stop-color:var(--lc);stop-opacity:.95'/><stop offset='.45' style='stop-color:var(--lc);stop-opacity:.42'/><stop offset='1' style='stop-color:var(--lc);stop-opacity:0'/></linearGradient>` +
      `<linearGradient id='${id}dn' x1='0' y1='0' x2='0' y2='1'><stop offset='0' style='stop-color:var(--lc);stop-opacity:.95'/><stop offset='.5' style='stop-color:var(--lc);stop-opacity:.4'/><stop offset='1' style='stop-color:var(--lc);stop-opacity:.04'/></linearGradient>` +
      `<radialGradient id='${id}pool'><stop offset='0' style='stop-color:var(--lc);stop-opacity:1'/><stop offset='.45' style='stop-color:var(--lc);stop-opacity:.55'/><stop offset='1' style='stop-color:var(--lc);stop-opacity:0'/></radialGradient>` +
      `<linearGradient id='${id}gold' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#e9cf91'/><stop offset='.5' stop-color='#b68a4c'/><stop offset='1' stop-color='#7d5a28'/></linearGradient>`;
    var wall = el('rect', { x: -2000, y: -2000, width: W + 4000, height: H + 4000 }, svg);
    el('rect', { x: -2000, y: -2000, width: W + 4000, height: H + 4000, filter: 'url(#' + id + 'n)' }, svg);
    el('rect', { x: -2000, y: H - 34, width: W + 4000, height: 3000, fill: '#000', opacity: '.28' }, svg);
    var wet = el('rect', { x: -2000, y: -2000, width: W + 4000, height: H + 4000, fill: 'url(#' + id + 'dn)', opacity: 0 }, svg);
    var light = el('g', { style: 'mix-blend-mode:screen' }, svg);
    var fix = el('g', {}, svg);
    var shape = CFG.form;
    var fit = function () {
      var r = stage.getBoundingClientRect(); if (!r.width || !r.height) return;
      var ar = r.width / r.height;
      var Z = shape === 'stone' ? 1.75 : 1;
      if (ar >= 1.55) { var dw = W / Z, dh = H / Z; svg.setAttribute('viewBox', (800 - dw / 2) + ' ' + (500 - dh / 2) + ' ' + dw + ' ' + dh); return; }
      var vw = { wave: 1340, twin: 1340, stone: 720, cube: 1000 }[shape] || 1150, vh = vw / ar;
      svg.setAttribute('viewBox', (800 - vw / 2) + ' ' + (500 - vh / 2) + ' ' + vw + ' ' + vh);
    };
    fit(); window.addEventListener('resize', fit);

    var R = {};
    function cube() {
      var cx = 800, cy = 520, s = 150;
      R.up = el('polygon', { fill: 'url(#' + id + 'up)', filter: 'url(#' + id + 'b1)' }, light);
      R.dn = el('polygon', { fill: 'url(#' + id + 'dn)', filter: 'url(#' + id + 'b1)' }, light);
      R.glow = el('ellipse', { cx: cx, cy: cy, rx: 220, ry: 300, fill: 'url(#' + id + 'pool)', filter: 'url(#' + id + 'b3)', opacity: .35 }, light);
      R.hotU = el('ellipse', { cx: cx, cy: cy - s / 2 - 6, rx: 58, ry: 14, fill: 'var(--lc)', filter: 'url(#' + id + 'b1)' }, light);
      R.hotD = el('ellipse', { cx: cx, cy: cy + s / 2 + 6, rx: 58, ry: 14, fill: 'var(--lc)', filter: 'url(#' + id + 'b1)' }, light);
      el('rect', { x: cx - s / 2 + 8, y: cy - s / 2 + 10, width: s, height: s, rx: 4, fill: '#000', opacity: .35, filter: 'url(#' + id + 'b1)' }, fix);
      R.body = el('rect', { x: cx - s / 2, y: cy - s / 2, width: s, height: s, rx: 3, fill: '#17181a' }, fix);
      el('rect', { x: cx - s / 2, y: cy - s / 2, width: s, height: 3, fill: '#3a3c3f' }, fix);
      el('rect', { x: cx - s / 2 + 3, y: cy - s / 2, width: 2, height: s, fill: '#2b2d30' }, fix);
      R.drops = el('g', { opacity: 0 }, fix);
      for (var i = 0; i < 46; i++) {
        var x = cx - s / 2 + 8 + Math.random() * (s - 16), y = cy - s / 2 + 8 + Math.random() * (s - 16), r = 1.2 + Math.random() * 2.6;
        el('ellipse', { cx: x, cy: y, rx: r, ry: r * 1.25, fill: '#fff', opacity: .18 + Math.random() * .35 }, R.drops);
      }
      R.geom = { cx: cx, cy: cy, s: s };
    }
    function twinOne(g, mirror) {
      var sp = el('g', { transform: mirror ? 'scale(-1,1)' : '' }, g);
      var parts = [{ x: -26, y: -330, w: 18, h: 560 }, { x: 10, y: -170, w: 18, h: 470 }, { x: 36, y: -60, w: 12, h: 170 }];
      var glowG = el('g', {}, R.lightG);
      parts.forEach(function (p) {
        el('rect', { x: p.x - 30, y: p.y - 20, width: p.w + 60, height: p.h + 40, rx: 30, fill: 'var(--lc)', opacity: .55, filter: 'url(#' + id + 'b2)', transform: mirror ? 'scale(-1,1)' : '' }, glowG);
        el('rect', { x: p.x, y: p.y, width: p.w, height: p.h, rx: 3, fill: 'var(--lc-hi)', class: 'kx-lit' }, sp);
      });
      el('rect', { x: -6, y: -110, width: 14, height: 240, rx: 2, class: 'kx-fin' }, sp);
    }
    function twin() {
      R.pairL = el('g', {}, fix); R.pairR = el('g', {}, fix);
      R.lightL = el('g', {}, light); R.lightR = el('g', {}, light);
      R.lightG = R.lightL; twinOne(R.pairL, false);
      R.lightG = R.lightR; twinOne(R.pairR, true);
      R.wash = el('ellipse', { cx: 800, cy: 500, rx: 700, ry: 420, fill: 'url(#' + id + 'pool)', filter: 'url(#' + id + 'b3)', opacity: .22 }, light);
    }
    function spot() {
      var bx = 520, by = 330;
      R.pool = el('ellipse', { rx: 210, ry: 150, fill: 'url(#' + id + 'pool)', filter: 'url(#' + id + 'b2)' }, light);
      R.cone = el('polygon', { fill: 'var(--lc)', opacity: .14, filter: 'url(#' + id + 'b2)' }, light);
      R.core = el('ellipse', { rx: 70, ry: 50, fill: 'var(--lc-hi)', filter: 'url(#' + id + 'b2)', opacity: .7 }, light);
      el('circle', { cx: bx + 6, cy: by + 10, r: 64, fill: '#000', opacity: .4, filter: 'url(#' + id + 'b1)' }, fix);
      el('circle', { cx: bx, cy: by, r: 62, fill: '#17181a' }, fix);
      el('circle', { cx: bx, cy: by, r: 62, fill: 'none', stroke: '#2e3033', 'stroke-width': 3 }, fix);
      R.sensor = el('circle', { cx: bx + 26, cy: by + 24, r: 6, fill: '#3c3f43' }, fix);
      R.head = el('g', {}, fix);
      el('rect', { x: -4, y: -22, width: 104, height: 44, rx: 10, fill: '#1d1e20' }, R.head);
      el('rect', { x: -4, y: -22, width: 104, height: 6, rx: 3, fill: '#34373a' }, R.head);
      R.lens = el('ellipse', { cx: 100, cy: 0, rx: 7, ry: 20, fill: 'var(--lc-hi)' }, R.head);
      R.geom = { bx: bx, by: by };
      el('rect', { x: 820, y: 760, width: 520, height: 14, fill: '#000', opacity: .35 }, fix);
      el('rect', { x: 880, y: 690, width: 34, height: 70, fill: '#000', opacity: .28 }, fix);
      el('rect', { x: 918, y: 708, width: 26, height: 52, fill: '#000', opacity: .22 }, fix);
      el('ellipse', { cx: 1160, cy: 730, rx: 44, ry: 30, fill: '#000', opacity: .25 }, fix);
    }
    /* Onda: two offset S-shaped bars crossing a vertical back plate, with a soft wash above and below the plate */
    function strip(x0, span, amp) {
      var pts = [], n = 56;
      for (var i = 0; i <= n; i++) { var t = i / n; pts.push((i ? 'L' : 'M') + (x0 + t * span).toFixed(1) + ' ' + (500 - amp * Math.sin(t * Math.PI * 2)).toFixed(1)); }
      return pts.join(' ');
    }
    function wave() {
      R.up = el('polygon', { points: '768,446 832,446 900,300 700,300', fill: 'url(#' + id + 'up)', filter: 'url(#' + id + 'b2)', opacity: .85 }, light);
      R.dn = el('polygon', { points: '768,554 832,554 900,700 700,700', fill: 'url(#' + id + 'dn)', filter: 'url(#' + id + 'b2)', opacity: .85 }, light);
      R.wG1 = el('path', { fill: 'none', stroke: 'var(--lc)', 'stroke-width': 40, opacity: .5, filter: 'url(#' + id + 'b2)', 'stroke-linecap': 'round' }, light);
      R.wG2 = el('path', { fill: 'none', stroke: 'var(--lc)', 'stroke-width': 40, opacity: .5, filter: 'url(#' + id + 'b2)', 'stroke-linecap': 'round' }, light);
      el('rect', { x: 774, y: 452, width: 58, height: 120, rx: 2, fill: '#000', opacity: .35, filter: 'url(#' + id + 'b1)' }, fix);
      R.plate = el('rect', { x: 770, y: 444, width: 60, height: 116, rx: 2, class: 'kx-fin' }, fix);
      R.wF1 = el('path', { fill: 'none', 'stroke-width': 13, class: 'kx-finS', 'stroke-linecap': 'round' }, fix);
      R.wF2 = el('path', { fill: 'none', 'stroke-width': 13, class: 'kx-finS', 'stroke-linecap': 'round' }, fix);
      R.wL1 = el('path', { fill: 'none', stroke: 'var(--lc-hi)', 'stroke-width': 8, 'stroke-linecap': 'round', class: 'kx-lit' }, fix);
      R.wL2 = el('path', { fill: 'none', stroke: 'var(--lc-hi)', 'stroke-width': 8, 'stroke-linecap': 'round', class: 'kx-lit' }, fix);
    }
    function stone() {
      R.sG = el('g', {}, light);
      R.halo = el('rect', { x: -200, y: -70, width: 400, height: 140, rx: 70, fill: 'var(--lc)', opacity: .9, filter: 'url(#' + id + 'b3)' }, R.sG);
      R.edge = el('rect', { x: -150, y: 26, width: 300, height: 14, rx: 7, fill: 'var(--lc-hi)', filter: 'url(#' + id + 'b1)' }, R.sG);
      el('rect', { x: 668, y: 474, width: 270, height: 68, rx: 3, fill: '#000', opacity: .35, filter: 'url(#' + id + 'b1)' }, fix);
      R.base = el('rect', { x: 665, y: 466, width: 270, height: 68, rx: 3 }, fix);
      R.grain = el('rect', { x: 665, y: 466, width: 270, height: 68, rx: 3, fill: '#000', filter: 'url(#' + id + 'grain)' }, fix);
      R.st = el('g', {}, fix);
      el('rect', { x: -150, y: -34, width: 300, height: 68, rx: 4, fill: '#000', opacity: .3, transform: 'translate(8,10)', filter: 'url(#' + id + 'b1)' }, R.st);
      el('rect', { x: -150, y: -34, width: 300, height: 68, rx: 4, fill: '#d8c8a6' }, R.st);
      el('rect', { x: -150, y: -34, width: 300, height: 68, rx: 4, fill: '#fff', filter: 'url(#' + id + 'trav)' }, R.st);
      for (var i = 0; i < 60; i++) {
        el('ellipse', { cx: -144 + Math.random() * 288, cy: -28 + Math.random() * 56, rx: .8 + Math.random() * 3.2, ry: .6 + Math.random() * 1.6, fill: '#6f5f45', opacity: .25 + Math.random() * .4 }, R.st);
      }
      R.stEdge = el('rect', { x: -150, y: 29, width: 300, height: 5, rx: 2, fill: 'var(--lc-hi)', class: 'kx-lit' }, R.st);
    }
    ({ cube: cube, twin: twin, spot: spot, wave: wave, stone: stone }[shape] || cube)();

    var hudK = $('[data-kx-hud-k]', root), hudL = $('[data-kx-hud-l]', root), note = $('[data-kx-note]', root);
    var flickBtn = $('[data-kx-flick]', root), switchGrp = $('[data-kx-switchgrp]', root);
    function curK() { return toneK(toneName(), S.step); }
    function render() {
      var k = curK(), c = k2rgb(shown(k)), hi = mix(c, [255, 255, 255], .55);
      var night = hex('#0d0e0f'), dusk = shape === 'cube' && S.rain ? hex('#2b3036') : hex('#5a554d');
      var wallC = mix(night, dusk, S.amb);
      var lit = S.on ? S.level : 0;
      var lightOp = lit * (1 - S.amb * .55) * (S.flick ? 0 : 1);
      svg.style.setProperty('--lc', css(c));
      svg.style.setProperty('--lc-hi', css(hi));
      wall.setAttribute('fill', css(wallC));
      light.setAttribute('opacity', lightOp.toFixed(3));
      root.style.setProperty('--kx-lab-glow', css(c, .16 * lightOp));
      $$('.kx-lit', svg).forEach(function (n) { n.setAttribute('opacity', (0.25 + 0.75 * lightOp).toFixed(3)); });
      var fk = finishKey(IDX.fin >= 0 ? getOpt('fin') : 'black');
      $$('.kx-fin', svg).forEach(function (n) { n.setAttribute('fill', fk === 'gold' ? 'url(#' + id + 'gold)' : FINISH[fk][0]); });
      $$('.kx-finS', svg).forEach(function (n) { n.setAttribute('stroke', fk === 'gold' ? 'url(#' + id + 'gold)' : FINISH[fk][0]); });
      if (shape === 'cube') {
        var g = R.geom, sp = 10 + S.beam * 420, half = 52;
        R.up.setAttribute('points', [g.cx - half, g.cy - g.s / 2, g.cx + half, g.cy - g.s / 2, g.cx + half + sp, 0, g.cx - half - sp, 0].join(' '));
        R.dn.setAttribute('points', [g.cx - half, g.cy + g.s / 2, g.cx + half, g.cy + g.s / 2, g.cx + half + sp * 1.1, H, g.cx - half - sp * 1.1, H].join(' '));
        R.glow.setAttribute('rx', 140 + S.beam * 260);
        R.drops.setAttribute('opacity', S.rain ? 1 : 0);
        wet.setAttribute('opacity', S.rain ? .07 * lit : 0);
      }
      if (shape === 'twin') {
        var hz = S.orient === 'h';
        R.pairL.setAttribute('transform', hz ? 'translate(470 500) rotate(90)' : 'translate(560 520)');
        R.pairR.setAttribute('transform', hz ? 'translate(1130 500) rotate(90)' : 'translate(1040 520)');
        R.lightL.setAttribute('transform', R.pairL.getAttribute('transform'));
        R.lightR.setAttribute('transform', R.pairR.getAttribute('transform'));
      }
      if (shape === 'spot') {
        var bx = R.geom.bx, by = R.geom.by, dx = S.aimX - bx, dy = S.aimY - by;
        var ang = Math.atan2(dy, dx), deg = ang * 180 / Math.PI, d = Math.sqrt(dx * dx + dy * dy);
        R.head.setAttribute('transform', 'translate(' + bx + ' ' + by + ') rotate(' + deg.toFixed(1) + ')');
        var tipX = bx + Math.cos(ang) * 100, tipY = by + Math.sin(ang) * 100;
        var spread = 0.16 + d / 4200, prx = 120 + d * .28, pry = prx * .72;
        R.pool.setAttribute('cx', S.aimX); R.pool.setAttribute('cy', S.aimY); R.pool.setAttribute('rx', prx); R.pool.setAttribute('ry', pry);
        R.core.setAttribute('cx', S.aimX); R.core.setAttribute('cy', S.aimY); R.core.setAttribute('rx', prx * .34); R.core.setAttribute('ry', pry * .34);
        var a1 = ang - spread, a2 = ang + spread, L = d + prx * .4;
        R.cone.setAttribute('points', [tipX, tipY, bx + Math.cos(a1) * L, by + Math.sin(a1) * L, bx + Math.cos(a2) * L, by + Math.sin(a2) * L].join(' '));
        R.sensor.setAttribute('fill', S.on ? css(hi) : '#3c3f43');
      }
      if (shape === 'wave') {
        var len = 900, sz = IDX.size >= 0 ? getOpt('size') : null;
        if (sz && /80/.test(sz)) len = 1200;
        var span = len * .68, amp = len > 1000 ? 40 : 34;
        var pA = strip(800 - len / 2, span, amp), pB = strip(800 + len / 2 - span, span, amp);
        R.wG1.setAttribute('d', pA); R.wG2.setAttribute('d', pB);
        R.wF1.setAttribute('d', pA); R.wF2.setAttribute('d', pB);
        R.wL1.setAttribute('d', pA); R.wL2.setAttribute('d', pB);
      }
      if (shape === 'stone') {
        var wk = woodKey(IDX.wood >= 0 ? getOpt('wood') : '');
        R.base.setAttribute('fill', wk === 'walnut' ? '#5a3a27' : '#c9a578');
        R.grain.setAttribute('opacity', wk === 'walnut' ? .55 : .3);
        var tr = 'translate(800 500) rotate(' + (-S.rot) + ')';
        R.st.setAttribute('transform', tr);
        R.sG.setAttribute('transform', tr);
      }
      if (hudK) hudK.textContent = (S.on ? k : 0) ? k + ' K' : (I18N.off || 'Off');
      var tn = toneName(), td = tones()[tn] || {};
      if (hudL) hudL.textContent = (td.label || tn || '') + (shape === 'spot' && S.on ? ' · ' + Math.round(S.level * 100) + '%' : '');
      if (note) note.textContent = td.note || '';
      $$('[data-kx-tone]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kx-tone') === tn ? 'true' : 'false'); });
      $$('.kx-chip__dot', root).forEach(function (d) {
        var kk = toneK(d.getAttribute('data-k'), 0), t2 = tones()[d.getAttribute('data-k')];
        if (t2 && Array.isArray(t2.k)) d.style.background = 'conic-gradient(' + t2.k.map(function (x) { return css(k2rgb(shown(x))); }).join(',') + ',' + css(k2rgb(shown(t2.k[0]))) + ')';
        else d.style.background = css(k2rgb(shown(kk)));
      });
      $$('[data-kx-opt]', root).forEach(function (b) { b.setAttribute('aria-pressed', getOpt(b.getAttribute('data-kx-opt')) === b.getAttribute('data-val') ? 'true' : 'false'); });
      if (switchGrp) {
        var tri = Array.isArray((tones()[tn] || {}).k);
        switchGrp.classList.toggle('is-off', !tri);
        if (flickBtn) flickBtn.disabled = !tri;
      }
    }

    /* seed local state from the first chip of each group, so the lab works even if the buy box is missing */
    $$('[data-kx-opt]', root).forEach(function (b) { var k = b.getAttribute('data-kx-opt'); if (!OPT[k]) OPT[k] = b.getAttribute('data-val'); });
    var firstTone = Object.keys(tones())[0]; if (firstTone && !OPT.tone) OPT.tone = firstTone;
    $$('[data-kx-tone]', root).forEach(function (b) {
      b.addEventListener('click', function () { S.step = 0; setOpt('tone', b.getAttribute('data-kx-tone')); render(); });
    });
    $$('[data-kx-opt]', root).forEach(function (b) {
      b.addEventListener('click', function () { setOpt(b.getAttribute('data-kx-opt'), b.getAttribute('data-val')); render(); });
    });
    var f1 = theForm();
    if (f1) f1.addEventListener('change', function () { S.step = 0; render(); });
    var amb = $('[data-kx-amb]', root);
    if (amb) { S.amb = amb.value / 100; amb.addEventListener('input', function () { S.amb = amb.value / 100; render(); }); }
    var beam = $('[data-kx-beam]', root);
    if (beam) { S.beam = beam.value / 100; beam.addEventListener('input', function () { S.beam = beam.value / 100; render(); }); }
    var rot = $('[data-kx-rot]', root);
    if (rot) { S.rot = +rot.value; rot.addEventListener('input', function () { S.rot = +rot.value; render(); }); }
    $$('[data-kx-orient]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        S.orient = b.getAttribute('data-kx-orient');
        $$('[data-kx-orient]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        render();
      });
    });
    if (flickBtn) flickBtn.addEventListener('click', function () {
      flickBtn.classList.toggle('is-flipped');
      S.flick = 1; render();
      setTimeout(function () { S.flick = 0; S.step++; render(); }, RM ? 0 : 140);
    });

    var touch = $('[data-kx-touch]', root);
    if (touch) {
      var holdT = null, rampT = null, dir = -1, held = false;
      var stopRamp = function () { clearTimeout(holdT); clearInterval(rampT); holdT = rampT = null; touch.classList.remove('is-holding'); };
      touch.addEventListener('pointerdown', function (e) {
        if (e.button && e.button !== 0) return;
        held = false;
        holdT = setTimeout(function () {
          held = true; S.on = true; touch.classList.add('is-holding');
          rampT = setInterval(function () {
            S.level += dir * 0.03;
            if (S.level <= 0.1) { S.level = 0.1; dir = 1; }
            if (S.level >= 1) { S.level = 1; dir = -1; }
            render();
          }, 40);
        }, 380);
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { touch.addEventListener(ev, stopRamp); });
      touch.addEventListener('click', function () {
        if (held) { held = false; return; }
        S.on = !S.on; touch.setAttribute('aria-pressed', S.on ? 'true' : 'false'); render();
      });
      touch.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowRight') { S.on = true; S.level = Math.min(1, S.level + .1); render(); e.preventDefault(); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowLeft') { S.on = true; S.level = Math.max(.1, S.level - .1); render(); e.preventDefault(); }
      });
    }

    if (shape === 'spot') {
      var toSvg = function (ev) {
        var pt = svg.createSVGPoint(); pt.x = ev.clientX; pt.y = ev.clientY;
        var m = svg.getScreenCTM(); if (!m) return null; return pt.matrixTransform(m.inverse());
      };
      var dragging = false;
      var aim = function (ev) {
        var p = toSvg(ev); if (!p) return;
        var bx = R.geom.bx, by = R.geom.by, dx = p.x - bx, dy = p.y - by, d = Math.sqrt(dx * dx + dy * dy);
        if (d < 180) { dx *= 180 / (d || 1); dy *= 180 / (d || 1); }
        if (d > 760) { dx *= 760 / d; dy *= 760 / d; }
        S.aimX = bx + dx; S.aimY = clamp(by + dy, 40, H - 60); render();
      };
      stage.style.touchAction = 'none';
      stage.addEventListener('pointerdown', function (e) { dragging = true; stage.classList.add('is-dragging'); aim(e); });
      window.addEventListener('pointermove', function (e) { if (dragging) aim(e); });
      window.addEventListener('pointerup', function () { dragging = false; stage.classList.remove('is-dragging'); });
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        var st = 30, mv = { ArrowLeft: [-st, 0], ArrowRight: [st, 0], ArrowUp: [0, -st], ArrowDown: [0, st] }[e.key];
        if (!mv) return; e.preventDefault(); S.aimX = clamp(S.aimX + mv[0], 100, W - 100); S.aimY = clamp(S.aimY + mv[1], 40, H - 60); render();
      });
      if (!RM) {
        var t0 = null, sweep = function (ts) {
          if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 1800), e2 = 1 - Math.pow(1 - p, 3);
          S.aimX = 900 + 250 * e2; S.aimY = 520 + 120 * e2; render(); if (p < 1 && !dragging) requestAnimationFrame(sweep);
        };
        var io0 = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io0.disconnect(); requestAnimationFrame(sweep); } }, { threshold: .4 });
        io0.observe(stage);
      }
    }
    if (shape === 'stone') {
      var rd = false;
      var angFrom = function (ev) {
        var pt = svg.createSVGPoint(); pt.x = ev.clientX; pt.y = ev.clientY;
        var m = svg.getScreenCTM(); if (!m) return; var p = pt.matrixTransform(m.inverse());
        var a = -Math.atan2(p.y - 500, p.x - 800) * 180 / Math.PI; if (a < 0) a += 180; if (a > 180) a -= 180;
        S.rot = Math.round(a); if (rot) rot.value = S.rot; render();
      };
      stage.style.touchAction = 'none';
      stage.addEventListener('pointerdown', function (e) { rd = true; stage.classList.add('is-dragging'); angFrom(e); });
      window.addEventListener('pointermove', function (e) { if (rd) angFrom(e); });
      window.addEventListener('pointerup', function () { rd = false; stage.classList.remove('is-dragging'); });
    }

    var rainBtn = $('[data-kx-raintgl]', root), cv = $('[data-kx-rain]', root);
    if (rainBtn && cv) {
      var ctx = cv.getContext('2d'), drops = [], raf = null, vis = false;
      var size = function () { var r = stage.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1); cv.width = r.width * dpr; cv.height = r.height * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
      var seed = function () { drops = []; var r = stage.getBoundingClientRect(); for (var i = 0; i < 170; i++) drops.push({ x: Math.random() * r.width, y: Math.random() * r.height, v: 9 + Math.random() * 9, l: 10 + Math.random() * 18 }); };
      var tick = function () {
        var r = stage.getBoundingClientRect(), w = r.width, h = r.height;
        ctx.clearRect(0, 0, w, h);
        var c = k2rgb(shown(curK())), m = svg.getScreenCTM(), sr = stage.getBoundingClientRect(), ox = m.e - sr.left, oy = m.f - sr.top, cx = m.a * 800 + ox, sp = (10 + S.beam * 420) * m.a, half = 52 * m.a, cubeTop = m.d * (R.geom.cy - R.geom.s / 2) + oy, cubeBot = m.d * (R.geom.cy + R.geom.s / 2) + oy, top0 = oy, bot0 = m.d * H + oy;
        for (var i = 0; i < drops.length; i++) {
          var d = drops[i]; d.y += d.v; d.x -= d.v * .12;
          if (d.y > h) { d.y = -20; d.x = Math.random() * (w + 60); }
          var inBeam = false;
          if (S.on && d.y < cubeTop) { var f = clamp((cubeTop - d.y) / (cubeTop - top0), 0, 1.5), hw = half + sp * f; inBeam = Math.abs(d.x - cx) < hw; }
          else if (S.on && d.y > cubeBot) { var f2 = clamp((d.y - cubeBot) / (bot0 - cubeBot), 0, 1.5), hw2 = half + sp * 1.1 * f2; inBeam = Math.abs(d.x - cx) < hw2; }
          ctx.strokeStyle = inBeam ? css(c, .85 * (1 - S.amb * .5)) : 'rgba(210,220,235,' + (.16 + S.amb * .1) + ')';
          ctx.lineWidth = inBeam ? 1.6 : 1;
          ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x + d.l * .12, d.y - d.l); ctx.stroke();
        }
        raf = (S.rain && vis) ? requestAnimationFrame(tick) : null;
      };
      var start = function () { if (!raf && S.rain && vis) { raf = requestAnimationFrame(tick); } };
      new IntersectionObserver(function (es) { vis = es[0].isIntersecting; start(); }, { threshold: 0 }).observe(stage);
      window.addEventListener('resize', function () { size(); });
      rainBtn.addEventListener('click', function () {
        S.rain = !S.rain; rainBtn.setAttribute('aria-pressed', S.rain ? 'true' : 'false');
        stage.classList.toggle('is-rain', S.rain);
        if (S.rain) { size(); seed(); if (RM) { tick(); } else start(); } else { ctx.clearRect(0, 0, cv.width, cv.height); }
        render();
      });
    }
    render();
    stage.classList.add('is-ready');
  });
})();
